export default function ArrowRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.75 8.74995L25 15.0001L18.75 21.25" stroke="#2A3845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M25 15H4.99999" stroke="#2A3845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
